import { Localized } from './localizedStrings';
import { SystemRoles, hasAllAppRoles, hasAnyAppRole, systemConfigurationAdminRoles, systemDiagnosticsRoles, systemTenantRoles, systemSystemAdminRoles, systemMemberRoles } from './rolesAndPermissions';

const HOMEKEY: string = 'home';

/**
 * Returns a dashboard navigation link object
 * @returns a navigation link object
 */
function getDashboardLink(): NavLink {
    return {
        name: Localized.get('dashboard'),
        path: '/',
        key: 'home',
        icon: 'SpeedHigh'
    };
}

/**
 * Returns a tenant navigation link object
 * @returns a navigation link object
 */
function getTenantLink(): NavLink {
    return {
        name: Localized.get('tenants'),
        path: '/tenants',
        key: 'tenants',
        icon: 'EMI',
        //isExpanded: true,
        //links: [
        //    {
        //        name: 'Activity',
        //        url: 'http://msn.com',
        //        key: 'key1',
        //        target: '_blank',
        //    },
        //    {
        //        name: 'MSN',
        //        url: 'http://msn.com',
        //        disabled: true,
        //        key: 'key2',
        //        target: '_blank',
        //    },
        //]
    };
}

/**
 * Returns a configuration navigation link object
 * @returns a navigation link object
 */
function getConfigurationLink(): NavLink {
    return {
        name: Localized.get('configuration'),
        path: '/configuration',
        key: 'configuration',
        icon: 'Settings'
    };
};

/**
 * Returns a diagnostics navigation link object
 * @returns a navigation link object
 */
function getDiagnosticsLink(): NavLink {
    return {
        name: Localized.get('diagnostics'),
        path: '/diagnostics',
        key: 'diagnostics',
        icon: 'Diagnostic'
    };
}

/**
 * Returns a users navigation link object
 * @returns a navigation link object
 */
function getUsersLink(): NavLink {
    return {
        name: Localized.get('users'),
        path: '/users',
        key: 'users',
        icon: 'Group'
    }
}

/**
 * Returns a users navigation link object
 * @returns a navigation link object
 */
function getAuditsLink(): NavLink {
    return {
        name: Localized.get('audits'),
        path: '/audits',
        key: 'audits',
        icon: 'ComplianceAudit'
    }
}

/**
 * Returns the primary navigation groups for the user based on their application roles
 * 
 * @param userAppRoles - the user's permitted application roles
 * @returns an array of navigation links that the user is permitted to see
 */
export function getPrimaryNavGroups(userAppRoles: string[]): NavGroup[] {
    const links: NavLink[] = [
        getDashboardLink()
    ];

    if (Array.isArray(userAppRoles)) {
        if (hasAnyAppRole(systemTenantRoles, userAppRoles)) {
            links.push(getTenantLink());
        }

        //if (hasAnyAppRole(systemDiagnosticsRoles, userAppRoles)) {
        //    links.push(getDiagnosticsLink());
        //}

        //if (hasAllAppRoles(systemConfigurationAdminRoles, userAppRoles)) {
        //    links.push(getConfigurationLink());
        //}

        if (hasAnyAppRole(systemMemberRoles, userAppRoles)) {
            links.push(getUsersLink());
        }

        // Add Audits at the bottom of the navigation
        if (hasAnyAppRole(systemDiagnosticsRoles, userAppRoles)) {
            links.push(getAuditsLink());
        }
    }

    return [
        { links }
    ];
}

/**
 * Returns the navigation key for the specified path
 *
 * @param path - the specified path
 * @returns the navigation key for the specified path
 */
export function getNavKeyFromPath(path: string): string {
    const paths: string[] = path.split('/');
    paths.shift();

    if (paths.length > 0) {
        const navKey: string = paths.join('-');
        if (navKey !== '') {
            return navKey;
        }
    }

    return HOMEKEY;
}